import React, { Component } from 'react'
import { Navbar, Nav } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import './Navigation.css';
import navbarLogo from '../../assets/AppName.png';

export default class Navigation extends Component {
    render() {
        return (
            <React.Fragment>
                <div className='navbar-container d-flex justify-content-between align-center'>
                    <div className="admin-app-logo">
                        <img src={navbarLogo} alt='Elmaam Logo' />
                        {/* <span className='camphire-main-logo-text'></span> */}
                    </div>
                    <div className="navbar-option">
                        <span id="username"></span>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
